import { type Supplier } from "@/api/suppliers";

import { supplierEntity } from "./entities";
import { EntityCombobox } from "./EntityCombobox";

interface Props {
  value: number | null;
  onChange: (id: number | null) => void;
  size?: "sm" | "default";
  className?: string;
  allowClear?: boolean;
}

export function SupplierCombobox({ allowClear = true, ...rest }: Props) {
  return (
    <EntityCombobox<Supplier>
      descriptor={supplierEntity}
      allowClear={allowClear}
      {...rest}
    />
  );
}
